var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"tabs__wrap",staticClass:"m-tabs__wrap"},[_c('div',{ref:"tabs__scroll",staticClass:"m-tabs__scroll"},[_c('div',{staticClass:"m-tabs__nav"},[(_vm.lineHeight)?_c('div',{staticClass:"m-tabs__line",style:(_vm.styles)}):_vm._e(),_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }